/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Week_ThisInputs */

const en_history_week_this = /** @type {(inputs: History_Week_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week`)
};

const de_history_week_this = /** @type {(inputs: History_Week_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Woche`)
};

/**
* | output |
* | --- |
* | "This week" |
*
* @param {History_Week_ThisInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_week_this = /** @type {((inputs?: History_Week_ThisInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Week_ThisInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_week_this(inputs)
	return en_history_week_this(inputs)
});